import { instance } from '@/services/avik-api-gateway'
import { DeviationCrew } from '@/types/deviation-crew'
import { AxiosResponse } from 'axios'

export function createDeviationCrew(
  body: Partial<DeviationCrew>
): Promise<AxiosResponse<DeviationCrew>> {
  return instance.post(`/deviation-crew`, body)
}
